<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "error-outer" },
    [
      _c("vue-recaptcha", {
        key: _vm.captchaKey,
        ref: "recaptcha",
        attrs: { sitekey: _vm.sitekey },
        on: { verify: _vm.onCaptchaVerified, expired: _vm.onCaptchaExpired },
      }),
      _c("Errors", { attrs: { error: _vm.captchaErr } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/views/auth/ReCaptcha.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import EventBus from '@/EventBus';
import * as vuerecaptcha from 'vue-recaptcha';
import layouts_components_Errors_vue from '@/layouts/components/Errors.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//




export default ({
  render,
  staticRenderFns,
  components: {
    VueRecaptcha: vuerecaptcha["VueRecaptcha"],
    Errors: layouts_components_Errors_vue
  },
  props: {
    verifyCaptcha: {
      type: Function,
      default: () => {}
    },
    captchaErr: {
      type: String,
      default: () => {}
    }
  },
  created() {
    EventBus.$on("reset_captcha", this.resetCaptcha);
  },
  data() {
    return {
      loading: true,
      captcha: "",
      sitekey: "6Lf9IWQpAAAAACd2dqW6Bpo4NtPg-X_8vLOxXsub",
      captchaKey: 1
    };
  },
  methods: {
    onCaptchaVerified(response) {
      this.captcha = response;
      this.status = true;
      this.verifyCaptcha(true, response);
    },
    onCaptchaExpired() {
      this.status = false;
      this.verifyCaptcha(false, "");
      this.$refs.recaptcha.reset();
    },
    resetCaptcha() {
      this.captchaKey += 1;
      this.status = false;
      this.verifyCaptcha(false, "");
      if (this.$refs && this.$refs.recaptcha) {
        this.$refs.recaptcha.reset();
      }
    }
  }
});

//# sourceURL=webpack:///./src/views/auth/ReCaptcha.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

